// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9244) return "static/chunks/9244-8389048fdc661229.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"c64fb3781187c833","822":"c5560b6e3163fb04","2121":"366c3d34b9c706f3","4316":"fa34d13f53bfedc2","4382":"21fc5a1a49b80346","8891":"0a77e3c506afb3f0"}[chunkId] + ".js";
};